<section class="dds__dell-container stroked container-blue" aria-label="Headline Stroked: Dell-Blue" style="margin: 3rem;color: #00447c;">
    <div class="dds__dell-container-body" style="line-height: 2rem;">

      
      <h2 class="dds__dell-container-title"  style="font-weight: 300; color: black;"><span style="font-weight: 400; color: #00447c;">Part Number: </span><a class="tooltip" href="javascript:void(0)" style="cursor: pointer; color: #00447c;" (click)="openPartDetails()">{{partNumber}}
        <span class="tooltiptext">View Details</span></a></h2>

      <h4 class="dds__dell-container-title" style="margin-top: 2%;">
        <span style="font-weight: 500;color: #00447c;">Revision: </span><span style="color: black;font-weight: 500;">{{partRevision}}</span> <br>
      </h4>
    </div>
  </section>

  <div id="dds__full-screen-overlay" class="dds__overlay"></div>
<app-part-info-modal ng-init="expression" modalId="fromageId" modalTitleId="fromageTitle">
  <div modal-title>
      <div>Part Info</div>
  </div>
  <div modal-body>     
    <div class="fixTableHead dds__table-striped" style="margin: 1rem;overflow: auto; height: auto;
          min-height: 25vh; max-height: 45vh;">
            <table class="dds__table">
                <thead>
    
                    <tr>
                      <th style="width: 50%; color:#0076ce;">Item Attribute</th>
                      <th style="width: 50%; color:#0076ce;">Attribute Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <span style="font-weight: bold;">Part Number:</span>
                        </td>
                        <td>
                          <span>{{partAttributes.partNumber}}</span>
                        </td>
                    </tr>
                    <tr>
                      <td>
                          <span style="font-weight: bold;">Part Revision:</span>
                      </td>
                      <td>
                        <span>{{partAttributes.partRevision}}</span>
                      </td>
                  </tr>
                    <tr>
                      <td>
                          <span style="font-weight: bold;">Part Class:</span>
                      </td>
                      <td>
                        <span>{{partAttributes.partClass}}</span>
                      </td>
                  </tr>
                  <tr>
                    <td>
                        <span style="font-weight: bold;">Software Bundle Type:</span>
                    </td>
                    <td>
                      <span>{{partAttributes.swbtype}}</span>
                    </td>
                </tr>
                
              <tr>
                <td>
                    <span style="font-weight: bold;">Proj-Platforms Affected:</span>
                </td>
                <td>
                  <span>{{partAttributes.partPpa}}</span>
                </td>
            </tr>
            <tr>
              <td>
                  <span style="font-weight: bold;">E-Promoted Platforms:</span>
              </td>
              <td>
                <span>{{partAttributes.ePromotedPlatforms}}</span>
              </td>
          </tr>
          <tr>
            <td>
                <span style="font-weight: bold;">Operating Systems:</span>
            </td>
            <td>
              <span>{{partAttributes.operatingSystems}}</span>
            </td>
        </tr>
      <tr>
          <td>
              <span style="font-weight: bold;">Languages:</span>
          </td>
          <td>
            <span>{{partAttributes.languages}}</span>
          </td>
      </tr>
      <tr>
        <td>
            <span style="font-weight: bold;">Royalty Flag:</span>
        </td>
        <td>
          <span>{{partAttributes.royaltyFlag}}</span>
        </td>
      </tr>
      <tr>
        <td>
            <span style="font-weight: bold;">Regions Affected:</span>
        </td>
        <td>
          <span>{{partAttributes.regionsAffected}}</span>
        </td>
      </tr>
      <tr>
        <td>
            <span style="font-weight: bold;">LOBs Affected:</span>
        </td>
        <td>
          <span>{{partAttributes.lobsAffected}}</span>
        </td>
    </tr>
                </tbody>
            </table>
        </div>
      
  </div>
<div modal-footer>
  <button class="dds__btn dds__btn-secondary" style="text-align: right;border-color: black;" data-dismiss="dds__modal">Close</button>
</div>
<span modal-trigger id="modalPartTrigger"></span>
</app-part-info-modal>